













import { defineComponent, computed } from '@vue/composition-api'
import { VIDEO, AUDIO, IMAGE, LINK } from '@/shared/media/mediaTypes'
import VideoItem from './VideoItem.vue'
import AudioItem from './AudioItem.vue'
import ImageItem from './ImageItem.vue'
import LinkItem from './LinkItem.vue'
import { mediaItemFileVersionLink, mediaItemFileLink } from '@/shared/api'

export default defineComponent({
  name: 'MediaItem',
  components: {
    VideoItem,
    AudioItem,
    ImageItem,
    LinkItem,
  },
  props: {
    mediaItem: Object,
  },
  setup(props) {
    const link = computed(() => {
      if (props.mediaItem.type !== 'link' && !props.mediaItem.file) {
        return
      }

      if (props.mediaItem.type === 'link') {
        return props.mediaItem.filename
      }

      if (props.mediaItem.file?.id) {
        return mediaItemFileVersionLink(
          props.mediaItem.id,
          props.mediaItem.file.id
        )
      }

      return mediaItemFileLink(props.mediaItem.id)
    })

    const componentName = computed(() => {
      const type = props.mediaItem.type
      let componentName
      switch (type) {
        case VIDEO:
          componentName = 'LinkItem'
          break
        case AUDIO:
          componentName = 'AudioItem'
          break
        case IMAGE:
          componentName = 'ImageItem'
          break
        case LINK:
          componentName = 'LinkItem'
          break
        default:
          componentName = 'LinkItem'
          break
      }

      return componentName
    })

    return {
      componentName,
      link,
      LINK,
    }
  },
})
